import { pathgen } from 'object-path-generator';
export const SuggestedDescriptionDisplayTestIds = pathgen('SuggestedDescriptionDisplayTestIds');
export const suggestedDescriptionTextsPath = 'helpMeWrite.suggestedDescription';
export const isPromptQuestion = (param)=>{
    let { description, promptText } = param;
    return description === promptText;
};
